import { DashboardLayout } from "../types/org-dashboard";

export const orgDashboardLayoutKey = "periscope-org-dashboard-layout";
export const orgDashboardLayoutEvent = orgDashboardLayoutKey + "-event";

/** Card ids. Kept as constants so a stored layout survives a rename. */
export const IDENTITY_CARD = "identity";
export const ACCESS_CARD = "access";
export const USAGE_CARD = "usage";
export const LINKS_CARD = "links";
export const PLAN_STATUS_CARD = "plan-status";
export const SEATS_CARD = "seats";
export const BILLING_CARD = "billing";
export const TERM_CARD = "term";
/** The original full panes, kept available for every action they contain. */
export const ORG_DETAILS_CARD = "org-details";
export const SUBSCRIPTION_DETAILS_CARD = "subscription-details";

/** Total grid width, and the narrowest a column or split part may become. */
export const GRID_COLUMNS = 12;
export const MIN_COLUMN_SPAN = 3;

/**
 * Widths offered in the column menu. Five and seven are here so the default
 * pair can be restored by hand: a width you cannot pick is a width you cannot
 * get back to without resetting the whole layout.
 */
export const COLUMN_SPAN_OPTIONS = [3, 4, 5, 6, 7, 8, 9, 12];

/**
 * Seven and five, keeping the two-pane shape the page has always had — org
 * information on the left, subscription and billing on the right.
 *
 * The org side still takes the larger share, because its values are the long
 * ones: emails, ids, a dropdown. But four columns left the subscription side
 * carrying more content than it had room for — its cards ran a good deal
 * taller than the org cards beside them, and the term dates and component
 * columns had to wrap. Five evens the two columns up without costing the org
 * side its owner email.
 */
export const defaultOrgDashboardLayout: DashboardLayout = {
  columns: [
    {
      width: 7,
      items: [
        { id: IDENTITY_CARD },
        { id: ACCESS_CARD },
        { id: USAGE_CARD },
        { id: LINKS_CARD },
      ],
    },
    {
      width: 5,
      items: [
        { id: PLAN_STATUS_CARD },
        { id: SEATS_CARD },
        { id: BILLING_CARD },
        { id: TERM_CARD },
      ],
    },
  ],
};

/**
 * The page as it was before the cards: the two full detail panes, six and six.
 *
 * Kept as a preset rather than a migration path - the panes hold every action
 * the focused cards do not, and some people would rather read the tables they
 * already know than learn where each fact moved to.
 */
export const classicOrgDashboardLayout: DashboardLayout = {
  columns: [
    { width: 6, items: [{ id: ORG_DETAILS_CARD }] },
    { width: 6, items: [{ id: SUBSCRIPTION_DETAILS_CARD }] },
  ],
};
